import React from 'react'
import { array, string, object } from 'prop-types'

class DirectionsDropdown extends React.Component {
  getType (productClass) {
    if (productClass === 'HCP' || productClass === 'HO') return 'hotelLocations'
    if (productClass === 'LO') return 'loungesLocations'
    return 'parkingLocations'
  }

  getData () {
    const { location, pageData: { productClass } } = this.props
    try {
      const type = this.getType(productClass.toUpperCase())
      let prodlib = require('../../../../config/exports/buildTimeOnly/' + type + '/' + location.code + '.json')
      return prodlib || false
    } catch (e) {
      return false
    }
  }

  getItems () {
    const { functionParams, id } = this.props
    const products = this.getData()
    if (!products) return null
    const type = functionParams[0] || 'directions'
    let options = []
    Object.keys(products).map(key => {
      const { prodlib, links } = products[key]
      if (!prodlib || !prodlib.name || !links || !links[type]) return null
      let option = (<option key={id + key} value={`/${links[type]}.html`}>{prodlib.name}</option>)
      options.push(option)
    })
    return options
  }

  getDefaultText () {
    const { pageData: { productClass }, functionParams } = this.props
    // Default text override
    if (functionParams[2]) return functionParams[2]
    if (productClass === 'HCP' || productClass === 'HO') return 'Hotels'
    return 'Car Parks'
  }

  render () {
    const { functionParams, id, type } = this.props
    const text = functionParams[1] || 'For a map and directions to a particular hotel, select it from here:'
    const items = this.getItems()
    const defaultTextOptionText = this.getDefaultText()
    if (!items) return null
    return (
      <div id={id} className='directionsDropdown block-sm' data-track-name={`${type}LinkDropdown`} data-track-value='click'>
        <small>{text}</small>
        <select>
          <option>- {defaultTextOptionText} -</option>
          {items}
        </select>
      </div>
    )
  }
}

DirectionsDropdown.propTypes = {
  functionParams: array,
  id: string.isRequired,
  type: string,
  location: object,
  pageData: object
}

DirectionsDropdown.defaultProps = {
  functionParams: []
}

export default DirectionsDropdown



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/linksDropdown.jsx